export default "__VITE_ASSET__357f9dbc__"